/**
 * Columns of the substitute materials catalog listing.
 *
 * Each row carries a discontinued material and the material that replaces it. The relation is
 * direct: a substitute that is itself registered as discontinued in another row does not change
 * what this row shows, so no column resolves a chain.
 *
 * Titles are in English, matching the portal's interface language.
 */
export const substituteMaterialsConfig = [
	{
		title: 'Discontinued code',
		dataSource: 'ObsoleteMaterialCode',
		sortable: true
	},
	{
		title: 'Discontinued description',
		dataSource: 'ObsoleteMaterialDescription',
		sortable: true
	},
	{
		title: 'Substitute code',
		dataSource: 'SubstituteMaterialCode',
		sortable: true
	},
	{
		title: 'Substitute description',
		dataSource: 'SubstituteMaterialDescription',
		sortable: true
	}
]

export default substituteMaterialsConfig
